import {
	FREE_EDITION,
	STANDARD_EDITION,
	type ApplicationEdition,
} from '@atlassian/jira-shared-types/src/edition.tsx';
import { JIRA_TRIAL_LENGTH_14, JIRA_TRIAL_LENGTH_30 } from './constants.tsx';

export const getTrialLength = (
	currentEdition: ApplicationEdition,
	targetEdition: ApplicationEdition,
): number => {
	if (currentEdition === FREE_EDITION && targetEdition === STANDARD_EDITION) {
		return JIRA_TRIAL_LENGTH_14;
	}
	return JIRA_TRIAL_LENGTH_30;
};
